import React from "react";
import BookListStyled from "./BookListStyled.js"
import BookThumbStyled from "./BookThumbStyled.js"

const BookList = (props) => {
  const back = props.theme == "dark" ? "orange" : "palevioletred"
    return ( props.library.map(bk => (
    <BookListStyled 
      theme={props.theme} 
      key={bk.id}
      onClick={() => {
        props.chooseBook(bk.id, bk.firstChapterName, bk.firstSectionID)
      }}>
        <BookThumbStyled key={bk.id} theme={props.theme}>
          <div style={{ width: "400px", marginRight: "100px"}}>
              <strong > {bk.title}</strong>
              <span > {bk.subtitle} </span>
              </div>
              <div style={{backgroundColor: back, width: "170px", display: "flex", justifyContent: "center", alignItems: "center"}}> 
              
              {bk.date}</div>
        </BookThumbStyled>
    </BookListStyled> ))
  )
};
export default BookList



// WEBPACK FOOTER //
// ./src/containers/booklist/BookList.js